export default __webpack_public_path__ + "static/media/payment-logo-black.6d0d8092.png";